module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjQxIDAuNTlMMCAyTDYgOEwxMiAyTDEwLjU5IDAuNTlMNiA1LjE3TDEuNDEgMC41OVoiIGZpbGw9IiMzMzMzMzMiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down.svg
// module id = AjJ6
// module chunks = 1